<h1 mat-dialog-title>Import de données par fichier CSV</h1>
<div mat-dialog-content>
	<form role="form" class="form-horizontal">
		<input type="file"
			class="file-input"
			(change)="onFileSelected($event)"
			accept="text/csv"
			#fileInput
			>
	
		<div class="form-group row last-row">
			<label class="control-label col-md-2">Fichier&nbsp;*:</label>
			<div class="col-md-9 plus-half input-group">
				<input id="filename" name="filename"
				 	type="text"
					class="form-control"
					disabled
					placeholder="Sélectionnez un fichier"
					[ngModel]="(file$ | async)?.name"
					/>
				<div class="input-group-addon">
					<a href="#" onclick="return false;" title="Sélectionner un ficher" (click)="fileInput.click()">
						<span class="fa fa-lg fa-paperclip"></span>
					</a>
				</div>
			</div>
		</div>

		<div class="form-group row error-message" *ngIf="errorMessage">
			{{ errorMessage }}
		</div>
	</form>
</div>
<div mat-dialog-actions>
	<button class="btn btn-primary" [disabled]="waitingForServer || (importButtonDisabled$ | async)" mat-button cdkFocusInitial (click)="importRequest$.next()">Importer</button>
	&nbsp;
	<button class="btn btn-default" mat-button [mat-dialog-close]="false">Annuler</button>
</div>
